"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareSettlementDates = exports.getDateFnsLocale = void 0;
exports.formatDate = formatDate;
const locale_1 = require("date-fns/locale");
const dayjs_1 = __importDefault(require("dayjs"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const pino_1 = __importDefault(require("pino"));
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
dayjs_1.default.extend(customParseFormat_1.default);
const logger = (0, pino_1.default)();
const TsLocaleToDateFnsLocale = {
    cs: locale_1.cs,
    da: locale_1.da,
    es: locale_1.es,
    'en-US': locale_1.enUS,
    en_US: locale_1.enUS,
    'en-GB': locale_1.enGB,
    de: locale_1.de,
    fr: locale_1.fr,
    id: locale_1.id,
    it: locale_1.it,
    hu: locale_1.hu,
    ms: locale_1.ms,
    nl: locale_1.nl,
    nb: locale_1.nb,
    pl: locale_1.pl,
    pt: locale_1.pt,
    'pt-PT': 'pt-PT',
    ro: locale_1.ro,
    sk: locale_1.sk,
    fi: locale_1.fi,
    sv: locale_1.sv,
    'vi-VN': locale_1.vi,
    'he-IL': locale_1.he,
    'ar-SA': locale_1.ar,
    zh: locale_1.zhCN,
    'zh-TW': locale_1.zhTW,
    ja: locale_1.ja,
};
const getDateFnsLocale = (language) => TsLocaleToDateFnsLocale[language] ?? locale_1.enUS;
exports.getDateFnsLocale = getDateFnsLocale;
function isValidLocale(locale) {
    try {
        const formattedLocale = locale.replaceAll('_', '-');
        Intl.getCanonicalLocales(formattedLocale);
        return true;
    }
    catch {
        return false;
    }
}
const localeBasedOnCardProvider = globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'en-GB' : 'en-US';
const DATE_FORMATS = [
    'YYYY-MM-DD',
    'DD-MM-YYYY',
    'MM/DD/YYYY',
    'DD/MM/YYYY',
    'YYYY/MM/DD',
    'DD.MM.YYYY',
    'YYYY.MM.DD',
    'MMM DD, YYYY',
    'DD MMM YYYY',
    'YYYY-MM-DDTHH:mm:ss.SSSZ',
];
function formatDate(date, locale = localeBasedOnCardProvider, timezoneId = 'UTC') {
    try {
        let dateObj;
        if (typeof date === 'string') {
            let parsedDate = (0, dayjs_1.default)(date).tz(timezoneId, true);
            if (!parsedDate.isValid()) {
                for (const format of DATE_FORMATS) {
                    parsedDate = (0, dayjs_1.default)(date, format).tz(timezoneId, true);
                    if (parsedDate.isValid()) {
                        break;
                    }
                }
            }
            if (!parsedDate.isValid()) {
                logger.error(`Invalid date string format: ${date}`);
                return date;
            }
            dateObj = parsedDate.toDate();
        }
        else if (typeof date === 'number') {
            const parsedDate = (0, dayjs_1.default)(date).tz(timezoneId, true);
            if (!parsedDate.isValid()) {
                logger.error(`Invalid timestamp: ${date}`);
            }
            dateObj = parsedDate.toDate();
        }
        else if (date instanceof Date) {
            dateObj = (0, dayjs_1.default)(date).tz(timezoneId, true).toDate();
        }
        else if (dayjs_1.default.isDayjs(date)) {
            dateObj = date.tz(timezoneId, true).toDate();
        }
        else {
            logger.error(`Unsupported date format: ${typeof date}`);
            return date;
        }
        const validLocale = isValidLocale(locale) ? locale.replaceAll('_', '-') : 'en-US';
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            timeZone: timezoneId,
        };
        let formattedDate = new Intl.DateTimeFormat(validLocale, options).format(dateObj);
        // custom HSBC format: 'DD MMM YYYY' ('05 Oct 2024')
        if (globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP) {
            const day = String(dateObj.getUTCDate()).padStart(2, '0');
            const month = dateObj.toLocaleString('en-US', { month: 'short', timeZone: timezoneId });
            const year = dateObj.getUTCFullYear();
            formattedDate = `${day} ${month} ${year}`;
        }
        return formattedDate;
    }
    catch (error) {
        logger.error(`Error formatting date: ${date}`, error);
        return String(date);
    }
}
const compareSettlementDates = (a, b, sortBy) => {
    const dateA = new Date(a.date ?? '').getTime();
    const dateB = new Date(b.date ?? '').getTime();
    return sortBy === 'most-recent' ? dateB - dateA : dateA - dateB;
};
exports.compareSettlementDates = compareSettlementDates;
